import React from 'react';
import type { RelatedListColumn } from '../../components/credit-block/SalesforceRelatedList';
import { getBureauLogo } from '../../constants/bureauLogos';
import type { BureauRelatedRow } from './creditBlockClientConstants';

export const BUREAU_RELATED_COLUMNS: RelatedListColumn<BureauRelatedRow>[] = [
  { key: 'creditBureauId', label: 'Credit Bureau ID', width: '22%' },
  {
    key: 'bureauName',
    label: 'Bureau Name',
    render: (row: BureauRelatedRow) => {
      const logo = getBureauLogo(row.bureauName.toLowerCase());
      return (
        <span className="inline-flex items-center gap-2">
          {logo && <img src={logo} alt="" className="h-5 w-5 object-contain" />}
          {row.bureauName}
        </span>
      );
    },
  },
  { key: 'stage', label: 'Stage' },
  { key: 'authority', label: 'Authority' },
];
